// extracted by mini-css-extract-plugin
export default {"buttonWithIcon":"ActionIcons_buttonWithIcon__AMGFY","buttonIcon":"ActionIcons_buttonIcon__3Kqna","tabIcon":"ActionIcons_tabIcon__j-gth","tabLabel":"ActionIcons_tabLabel__AGpl-"};